interface PageHeroProps {
  eyebrow: string;
  title: string;
  description?: string;
  image: string;
}

export default function PageHero({ eyebrow, title, description, image }: PageHeroProps) {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover object-top" />
      <div className="absolute inset-0"></div>
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="mx-auto max-w-7xl w-full px-4 md:px-10">
          <p className="text-white text-xs tracking-[0.4em] uppercase mb-4 drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">{eyebrow}</p>
          <h1 className="text-white font-heading text-background-50 text-3xl md:text-5xl leading-tight mb-4 drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">{title}</h1>
          {description && (
            <p className="text-white text-background-100/90 text-sm md:text-base max-w-2xl leading-relaxed drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}